import { type FormData, StepperStep } from '../../../types.ts';
import type { ShopifyOfferDto } from '../../../offer.types';
import type { CheckoutConfig } from '../../../services/checkoutConfig/checkoutConfig.types';

/**
 * Constantes para identificar seções editáveis do checkout
 */
export const DesignViewEditSectionEnum = {
  IDENTIFICATION: 'IDENTIFICATION',
  SHIPPING: 'SHIPPING',
  PAYMENT: 'PAYMENT'
} as const;

export type DesignViewEditSectionEnum = typeof DesignViewEditSectionEnum[keyof typeof DesignViewEditSectionEnum];

/**
 * Passos do checkout para o stepper
 */
export const CHECKOUT_STEPS: StepperStep[] = [
  new StepperStep(DesignViewEditSectionEnum.IDENTIFICATION, 'Informações pessoais'),
  new StepperStep(DesignViewEditSectionEnum.SHIPPING, 'Entrega'),
  new StepperStep(DesignViewEditSectionEnum.PAYMENT, 'Pagamento'),
];

/**
 * Props comuns para todos os designs de checkout
 */
export interface DesignViewCommonProps {
  formData: FormData;
  shopifyOffer?: ShopifyOfferDto;
  onEdit: (section: DesignViewEditSectionEnum) => void;
  onCouponApply: (couponCode: string) => Promise<void>;
  onPlaceOrder: () => void;
  isLoading?: boolean;
  /** Config do checkout (personalização por loja) — ver `services/checkoutConfig`. */
  checkoutConfig?: CheckoutConfig | null;
}


